import { component } from "picoapp";

export default component(async (node) => {
  const [{ $ }] = await Promise.all([
    import("jquery"),
    import("@fancyapps/fancybox/dist/jquery.fancybox.css"),
    import("@fancyapps/fancybox/dist/jquery.fancybox"),
  ]);

  window.jQuery = $;
  console.log("VIDEO SECTION LOADED");
});
